module.exports = __webpack_public_path__ + "static/media/kc-job-logo.457770fc.png";